// src/components/SEO.jsx
// Dynamic per-page meta tags using react-helmet-async
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://paoloallegretti.com';
const DEFAULT_IMAGE = `https://montevulture.it/varie/img/og-image.jpg`;
const SITE_NAME = 'Paolo Allegretti';

const SEO = ({
  title,
  description,
  url,
  image = DEFAULT_IMAGE,
  type = 'website',
  language = 'en',
  schema = null,
}) => {
  const fullTitle = title
    ? `${title} - Paolo Allegretti`
    : 'Paolo Allegretti - Senior Creative Technologist';

  const canonicalUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const htmlLang = language === 'it' ? 'it' : 'en';
  const ogLocale = language === 'it' ? 'it_IT' : 'en_GB';
  const ogLocaleAlt = language === 'it' ? 'en_GB' : 'it_IT';

  return (
    <Helmet>
      <html lang={htmlLang} />
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:locale:alternate" content={ogLocaleAlt} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={fullTitle} />

      {/* Language alternates — single URL per page, no separate locale paths */}
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

      {/* JSON-LD structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
